<lib-match-reporter-banner></lib-match-reporter-banner>
<ng-container *ngIf="items">
  <ng-container *ngFor="let item of items; let i = index">
    <!-- show all entries in website, limit in widget -->
    <lib-match-ticker-item *ngIf="EnvironmentService.isWebsite|| i < maxWidgetEntries"
                           [colorScheme]="colorScheme"
                           [item]="item"
                           [isFirst]="i === 0"
                           [isLast]="i === items.length - 1"
                           [pictures]="item.pictures"
                           [videos]="item.videos_native"
                           [data]="item.data"
                           [teamPictures]="matchTickerService.getTeamPictures(item.teamid)">
    </lib-match-ticker-item>
  </ng-container>
  <div *ngIf="EnvironmentService.isWidget && items?.length > maxWidgetEntries"
       class="match-ticker-fade-out">
    <a [href]="matchTickerService.tickerUrl" target="_blank">
      Mehr lesen
      <mat-icon>chevron_right</mat-icon>
    </a>
  </div>
  <span *ngIf="matchTickerService.items?.length === 0" class="match-ticker-info">
    Keine Einträge vorhanden
  </span>
</ng-container>
